// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"c-OrderMessage__wrapper"};